import type { TGafClassOption } from 'neuro-schemas/gaf';
import { arrayOfAll } from 'neuro-utils';
import { path } from 'Utility/ramdaReplacement';

export const docType = (documents: Array<IDocumentWithTypeV2<'madrs' | 'gaf'>>, editing: string): string | undefined =>
  editing
    ? path(
        ['_type'],
        documents.find(d => d._id === editing),
      )
    : undefined;

export const getHeaderId = (
  documents: Array<IDocumentWithTypeV2<'madrs' | 'gaf'>>,
  editing?: string,
  viewing?: string,
): string =>
  docType(documents, editing ?? viewing ?? '') === 'madrs'
    ? 'interviewSurveys.madrs.title'
    : docType(documents, editing ?? viewing ?? '') === 'gaf'
      ? 'interviewSurveys.gaf.title'
      : 'interviewSurveys.title';

export const gafClasses = arrayOfAll.options<TGafClassOption>()([
  '100-91',
  '90-81',
  '80-71',
  '70-61',
  '60-51',
  '50-41',
  '40-31',
  '30-21',
  '20-11',
  '10-01',
  '0',
]);
